export default __webpack_public_path__ + "static/media/pdf_document_with_pen.bc39b287.svg";